import { createFileRoute } from '@tanstack/react-router';
import {
    ACTIVE_MONITORING_COUNT,
    ACTIVE_TASK_COUNT,
    ActionSummaryStats,
} from '~/components/action-summary-stats';
import { MonitoringList } from '~/components/monitoring-list';
import { OpenActionsList } from '~/components/open-actions-list';
import { ACTIE_TABS, isActieTabKey, type ActieTabKey } from '~/lib/actie-tabs';

const HANDLED_TASK_COUNT = 847; // nepdata, veldnaam nog onbekend

// Aantal-badges in dezelfde kleuren als het menu. Openstaande acties en Monitoring
// gebruiken dezelfde aantallen als de bovenste balk.
const formatCount = (value: number) => new Intl.NumberFormat('nl-NL').format(value);
const TAB_BADGES: Partial<Record<ActieTabKey, { count: string; className: string }>> = {
    openstaand: { count: formatCount(ACTIVE_TASK_COUNT), className: 'bg-[#B2FF3C] text-[#202020]' },
    afgehandeld: { count: formatCount(HANDLED_TASK_COUNT), className: 'bg-[#ECEDED] text-[#8C8C8C]' },
    monitoring: { count: formatCount(ACTIVE_MONITORING_COUNT), className: 'bg-[#ECEDED] text-[#8C8C8C]' },
};

export const Route = createFileRoute('/_authenticated/acties')({
    validateSearch: (search: Record<string, unknown>): { tab: ActieTabKey } => ({
        tab: isActieTabKey(search.tab) ? search.tab : 'openstaand',
    }),
    component: ActiesPage,
});

function ActiesPage() {
    const { tab } = Route.useSearch();
    const navigate = Route.useNavigate();

    return (
        <div className="flex h-full flex-col">
            <h1 className="p-6 pb-0 text-[20px] font-bold text-[#202020]">Acties</h1>
            <div className="px-6 py-4">
                <ActionSummaryStats />
            </div>
            <div className="flex items-center gap-6 border-b border-[#F0F0F0] px-6">
                {ACTIE_TABS.map(({ key, label, icon: Icon }) => {
                    const active = tab === key;
                    return (
                        <button
                            key={key}
                            type="button"
                            onClick={() => navigate({ search: { tab: key } })}
                            className={`flex cursor-pointer items-center gap-1.5 border-b-2 py-3 text-[12px] ${
                                active ? 'border-[#202020] text-[#202020]' : 'border-transparent text-[#8C8C8C] hover:text-[#202020]'
                            }`}
                        >
                            <Icon className="size-4" stroke={1.75} />
                            {label}
                            {TAB_BADGES[key] ? (
                                <span
                                    className={`rounded-lg px-1.5 py-0.5 text-[11px] leading-none font-medium ${TAB_BADGES[key].className}`}
                                >
                                    {TAB_BADGES[key].count}
                                </span>
                            ) : null}
                        </button>
                    );
                })}
            </div>
            {tab === 'openstaand' ? <OpenActionsList /> : null}
            {tab === 'monitoring' ? <MonitoringList /> : null}
        </div>
    );
}
